import PDFJS from 'pdfjs-dist';
import fileParser from '../utils/fileParser';
const getPageText = async (pdf, pageNo) => {
  const page = await pdf.getPage(pageNo);
  const tokenizedText = await page.getTextContent();
  const pageText = tokenizedText.items.map(token => token.str).join('\n');
  return pageText;
};

// 'data' can be a url (string) or a Uint8Array (object)
const getPDFTextGroupedByPage = async data => {
  const pdf = await PDFJS.getDocument(data).promise;
  const pageTextPromises = [];
  for (let pageNo = 1; pageNo <= pdf.numPages; pageNo += 1) {
    pageTextPromises.push(getPageText(pdf, pageNo));
  }
  return Promise.all(pageTextPromises);
};

/**
 * @function evaluate - evaluate parsePDFTextBehavior
 *
 * Accept a public url or File blob and parse the contents.
 * Produce an array of pages with their text.
 */
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, evaluateSource) => {
  const fileURL = await evaluateSource(source.url, content, parentContentPath, transientContext, nativeFunctions);
  const file = await evaluateSource(source.file, content, parentContentPath, transientContext, nativeFunctions);
  if (fileURL) {
    return getPDFTextGroupedByPage(fileURL);
  }
  const {
    file: rawFile
  } = file;
  // creates a file reader and parses the File as an ArrayBuffer - returns Uint8Array
  const parsedFile = await fileParser.processRawFile(rawFile);
  return getPDFTextGroupedByPage(parsedFile);
};
export default {
  evaluate
};